import { makeAutoObservable } from "mobx";
import { ISite } from "../models/ISite";
import SiteService from "../service/SiteService";
import { toast } from "react-toastify";
import {
  showErrorToast,
  showLoadingToast,
  showSuccessToast,
} from "../components/toasts";

export default class Site {
  pageContent: ISite[] = [];
  loadingContentBool: boolean = true;
  reports: any = [];

  constructor() {
    makeAutoObservable(this);
  }


  setContent(content: ISite[]) {
    this.pageContent = content;
  }

  async loadList() {
    this.loadingContentBool = true;
    const list = await SiteService.fetchSiteContent();
    this.setContent(list.data);
    this.loadingContentBool = false;
    return list.data;
  }

  async loadReports() {
    console.log("loadin user")
    this.loadingContentBool = true;
    const list = await SiteService.fetchReports();
    console.log("newuser", list)
    this.loadingContentBool = false;
    this.reports = list.data;
    return list.data;
  }

  async updateReport(data: FormData | undefined) {
    showLoadingToast("Updating report...");
    if (typeof data !== "undefined") {
      await SiteService.updateReport(data);
      const reportData = await this.loadReports();
      showSuccessToast("Report updated");
      return reportData;
    } else {
      console.log("no data to update");
      showErrorToast("Error updating report");
    }
  }

  async updateOne(type: string, data: any | undefined) {
    this.loadingContentBool = true;
    showLoadingToast("Updating site content...");
    if (typeof data !== "undefined") {
      const res = await SiteService.fetchUpdateOne(data, type);
      await this.loadList();
      this.loadingContentBool = false;
      showSuccessToast("Site content updated");
      return res?.data;
    } else {
      console.log("no data to update");
      showErrorToast("Error updating site content");
    }
    this.loadingContentBool = false;
  }

  async deleteReport(id: any){
    try {
      const report = await SiteService.deleteReport(id);
      showSuccessToast("Property Reports Deleted Successfully")
      return report
    } catch (error) {
      console.log(error)      
    }
  }

  async loadOneReport(id:string) {
    try {
      const report = await SiteService.loadReport(id)
      return report
    } catch (error) {
      console.log(error)      
    }
  }
}
